<template>
    <div>
        <div class="sr-only" aria-live="polite">{{ accessibilityAnnouncement }}</div>
        <Splide aria-label="Day selection slider" role="region" :options="splideOptions" @splide:active="onSplideActive">
            <!-- <div v-for="(week, i) in weeks" :key="i"> -->
            <SingleDaySlideItem v-for="(day, index) in weeekData" :key="index" :day="day" :menuCycle="day.menuCycle"
                :userLoginCheck="userLoginCheck" :products="products" :excludeDays="excludeDays"
                :isActive="activeSlideIndex === index" :isLoaded="loadedSlideIndices.has(index)" />

        </Splide>
    </div>
</template>

<script>
import SingleDaySlideItem from './SingleDaySlideItem.vue';

var moment = require('moment');

export default {
    props: ['day', 'index', 'menuCycle', 'searchForm', 'weeks', 'excludeDays', 'isMenuPlanner', 'allDays', 'userLoginCheck'],
    components: { SingleDaySlideItem },

    data() {
        return {
            cal_days: null,
            moment: moment,
            is_assembly_instructions: false,
            cart_id_for_remove: '',
            showCartIcon: false,
            activeSlideIndex: 0,
            loadedSlideIndices: new Set([0]),
            slideDataCache: new Map(),
            splideOptions: {
                perPage: 1,
                type: 'slide',
                pagination: false,
                rewind: false,
                perMove: 1,
                focus: 'center',
                padding: '20%',
                start: 1,
                breakpoints: {
                    767: {
                        perPage: 1,
                        focus: 0,
                        padding: '0%',
                    },
                }

            },
            menuCycleData: [],
            options: [],
            accessibilityAnnouncement: ""
        }
    },
    computed: {
        products: function () {
            this.cal_days = null;
            let $this = this;
            if (this.menuCycle) {
                console.log("Menucycleview", this.menuCycle);
                let options = [];
                this.menuCycle.menu_cycle_days.forEach(mcdays => {
                    if (mcdays.day_of_week_number - 1 == $this.index) {
                        $this.is_assembly_instructions = mcdays.is_assembly_instructions;
                        options = mcdays.options;
                        $this.cal_days = mcdays;
                    }
                });

                return options;
            } else {
                $this.is_assembly_instructions = false;
                return [];
            }
        },
        weeekData() {
            this.weeks.map(item => {
                if (item.menuCycle) {
                    item.menuCycle.menu_cycle_days.map(day => {
                        let dayIndex = item.days.findIndex((_, key) => day.day_of_week_number - 1 == key);
                        if (dayIndex != -1) {
                            this.options.push({
                                date: item.days[dayIndex].date,
                                options: day.options
                            });
                        }
                    })
                }
            })

            var data = []

            this.weeks.map((item) => {
                data.push(...item.days);
            });
            data = data.map(item => {
                let i = this.options.findIndex(option => option.date == item.date);
                if (i != -1) {
                    item['options'] = this.options[i].options;
                } else {
                    item['options'] = [];
                }
                return item;
            });

            let currentDate = moment().format('MM-DD-YYYY');
            let currentDateIndex = data.findIndex(item => item.date == currentDate);
            if (currentDateIndex != -1) {
                this.splideOptions.start = currentDateIndex - 3;
            }
            return data;
            // var options = [];
            // data.map(item => {
            //     item.menu_cycle_days.forEach(mcdays => {
            //         if (mcdays.day_of_week_number - 1 == $this.index) {
            //             $this.is_assembly_instructions = mcdays.is_assembly_instructions;
            //             options = mcdays.options;
            //             $this.cal_days = mcdays;
            //         }
            //     });
            // })
            // var menuCycleData = [];
            // this.menuCycleData.map(menu => {
            //     menu.menu_cycle_days.map(day => {
            //         let weekdayIndex = data.findIndex(menuItem => menuItem.date == day.date.date);
            //         if (weekdayIndex != -1) {
            //             data[weekdayIndex]['menuCycle'] = menu;
            //         }
            //     });
            // })


        }

    },

    methods: {

        sortArrays(arrays) {
            return _.orderBy(arrays, 'sort_order', 'asc');
        },

        format_date(value) {
            if (value) {
                return moment(String(value)).format('DD')
            }
        },



        getOptionName(mc) {

            if (mc.name == '') {
                return "Option " + mc.sort_order;
            } else {
                return mc.name;
            }
        },

        getPhotoStorePath(mc) {
            if (mc.photo_store_path == '') {
                return "null";
            } else {
                return this.$page.props.storage_image_url + mc.photo_store_path;
            }
        },

        loadCalendar() {
            this.$emit('loadCalendar');
        },
        loadExcludedDateDataOnLoad(site, guide_line_id) {
            this.$emit('loadExcludedDateDataOnLoad', site, guide_line_id);
        },

        verifyExcludeDay(current_date) {
            // console.log('excludeDays');
            if (this.excludeDays) {
                // var new_date = moment(current_date).format('MM/DD/YYYY');
                var new_date = moment(current_date, 'MM-DD-YYYY').format('MM/DD/YYYY');
                let obj = this.excludeDays.find(o => o.date === new_date);
                if (obj) {
                    return true;
                } else {
                    return false;
                }
            }
            return false;

        },

        isShowMenu(cday) {
            return true;
        },
        onSplideActive(splide) {
            this.activeSlideIndex = splide.index;
            const activeSlide = this.weeekData[splide.index];
            if (activeSlide) {
                this.accessibilityAnnouncement = `Showing ${this.full_date(activeSlide.date)}`;
            }
            this.ensureSlideDataLoaded(splide.index);
        },
        ensureSlideDataLoaded(index) {
            if (this.loadedSlideIndices.has(index)) {
                return;
            }
            
            // Load previous slide if exists
            if (index > 0 && !this.loadedSlideIndices.has(index - 1)) {
                this.loadedSlideIndices.add(index - 1);
            }
            
            // Load current slide
            if (!this.loadedSlideIndices.has(index)) {
                this.loadedSlideIndices.add(index);
            }
            
            // Load next slide if exists
            if (index < this.weeekData.length - 1 && !this.loadedSlideIndices.has(index + 1)) {
                this.loadedSlideIndices.add(index + 1);
            }
        },
        full_date(value) {
            if (value) {
                let date;
                const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                if (isSafari) {
                    const parts = String(value).split('-');
                    date = new Date(`${parts[0]}/${parts[1]}/${parts[2]}`);
                } else {
                    date = new Date(value);
                }
                const options = { weekday: 'long', month: 'long', day: 'numeric' };
                return date.toLocaleDateString('en-US', options);
            }
        },

    }
};
</script>

<style scoped>
/* .button-none{
bottom: -100%;
z-index: 10;
} */

/* .box-hover{
overflow: hidden;
} */
/* .box-hover:hover .button-none{
bottom: 0;
} */

.bottom-0-space {
    bottom: 6px;
}
</style>

<style>
.font-24 {
    font-size: 24px;
}

.color-24 {
    color: #636363;
}

.p-color {
    color: #969696;
}

.p-size {
    font-size: 15px;
}

.online-color {
    color: #22af4b;
}

.offline-color {
    color: #cb0000;
}

.number-background-color {
    background-color: #cb0000;
}

.online-background-color {
    background-color: #22af4b;
}

.week-cycle-color {
    color: #1c2a47;
}

.week-cycle-fontsize {
    font-size: 14px;
}

.three-dot-color {
    color: #38558e;
}

.table-background {
    background-color: #f3f3f3;
}

.last-td-background {
    background-color: #f5f5f5;
}

.td-width {
    width: 14.28%;
    min-height: 135px;
    min-width: 170px;
}

.td-width .absolute-div {
    left: 35px;
}

.cart-color {
    color: #f7a53a;
}

.plus-font-size {
    font-size: 20px;
}

.menu-day-background {
    background-color: #cbcbcb;
}

.box-sizing {
    width: 100px;
    min-height: 60px;
}

.popup-shadow {
    box-shadow: 0px 5px 10px #0000005e;
}

.w-52 {
    width: 185px;
    width: 185px;
    max-height: 161px;
    overflow: auto;
    overflow-x: hidden;
}

.w-3 {
    width: 60px;
    min-height: 60px;
}

.hover_font_size {
    font-size: 13px;
    font-weight: bold;
    text-decoration: underline;
}

.title_color {
    color: #f7a53a;
}

.popup-shadow {
    box-shadow: 0px 5px 10px #0000005e;
}

.show-box {
    display: none;
}

.box-type-show:hover .show-box {
    display: block;
}

.absolute-div {
    position: absolute;
    top: 0px;
    left: 50px;
}

.add_food_color {
    background-color: #38558e;
}

.absolute-items {
    position: absolute;
    top: 0px;
    right: 0px;
    left: 0px;
    bottom: 0px;
    margin: auto;
}

.absolute-items2 {

    position: absolute;
    right: 8px;
    bottom: 8px;
    margin: auto;
}

.text-color-circle-icon {
    color: #38558e;
}

.mh-135 {
    min-height: 215px;
    padding: 4px;
}

.mh-135>div {
    padding: 4px;
}

.mh-135>div img {
    object-fit: cover;
}

span.option_title {
    line-height: 17px;
    padding-bottom: 10px;
}

/* splide slider css */
.splide__slide.is-next,
.splide__slide.is-prev {
    opacity: 0.4;
}

.splide__slide.is-active {
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
}

.slide_head {
    background-color: #365491;
    width: 100%;
    height: 3.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-weight: 600;
}

.splide__arrows {
    display: flex;
    justify-content: center;
    align-items: center;

}

.splide .splide__arrow {
    background: none;
    border: none;
    outline: none;
    top: 30px !important;
}

.splide__arrow.splide__arrow--prev {
    left: 21% !important;
}

.splide__arrow.splide__arrow--next {
    right: 21% !important;
}

.splide__arrow svg {
    fill: #fff;
}

@media screen and (max-width: 767px) {
    .splide__arrow.splide__arrow--prev {
        left: 1% !important;
    }

    .splide__arrow.splide__arrow--next {
        right: 1% !important;
    }

    .splide .splide__arrow {
        top: 30px !important;
        opacity: 1 !important;
    }
}

@media screen and (max-width: 1279px) {
    .splide .splide__arrow {
        top: 30px !important;
        opacity: 1 !important;
    }
}
</style>
